import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M10.6648 10.6725V2.66812C4.07715 2.66812 -1.12358 8.64473 0.209939 15.4751C1.02339 19.6374 4.37052 22.9859 8.53111 23.7997C15.6655 25.1871 21.333 19.1171 21.333 13.3406H13.3318C11.8649 13.3406 10.6648 12.1533 10.6648 10.6725ZM9.03786 21.1849C5.93075 20.5846 3.43706 18.0899 2.82363 14.9682C1.81016 9.75199 5.82407 6.32346 7.99771 5.56304V10.6725C7.99771 13.6208 10.3847 16.0087 13.3318 16.0087H18.2125C17.0657 18.7702 13.6519 22.0921 9.03786 21.1849ZM15.9989 10.6725H24C24 4.77594 19.226 0 13.3318 0V8.00437C13.3318 9.48518 14.532 10.6725 15.9989 10.6725ZM15.9989 2.89492C18.2658 3.69536 20.0661 5.73646 20.8796 8.00437H15.9989V2.89492Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
